import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, distinctUntilChanged, filter, map, mergeMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JwtService } from '../index.service';
import { IAnalyze } from 'src/app/shared/interfaces/analyze.interface';
import { Action } from 'rxjs/internal/scheduler/Action';
import { MultipleCriteria } from 'src/app/shared/interfaces/multiple-criteria.interface';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {
  readonly BASE_URL = environment.BASE_API_URL;
  readonly QUIZ_BASE_URL = environment.QUIZ_API_URL;
  username:string = ''
  organListUsername:string[] = []
  reportCardSettingBar:BehaviorSubject<boolean> = new BehaviorSubject(false)
  analysisCount = 1;
  quizList:any[] = []
  programProgressObj:any = {
    "firstStep":{action:'ADD',loading:false},
    "secondStep":{action:'ADD',loading:false},
    "profileStep":{action:'ADD',loading:false},
    "thirdStep":{action:'ADD',loading:false},
    "fourthStep":{action:'ADD',loading:false},
  }
  firstForm:any
  charactersForm:any
  profileRequiredDatasForm:any
  requiredDatasForm:any
  requiredQuizForm:any
  finalDataForm:any
  constructor(
    private http:HttpClient,
    public jwtService:JwtService
  ) { }

  initializeNewProgram(data:any){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.post<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/form/`,data,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getAnalyzeListData(secretKey:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/${secretKey}/`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getSingleAnalyzeData(analyzeId:any){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/${analyzeId}/`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  editProgramFirstStep(data:any,progId:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.patch<any>(`${this.QUIZ_BASE_URL}analysis/form/${progId}/`,data,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  editprogramDataSteps(data:any,progUsername:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.patch<any>(`${this.QUIZ_BASE_URL}analysis/${progUsername}/`,data,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteRequiredDataType(analysis_id:string,id:any){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/required_data/${id}/`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteProfileRequiredDataType(analysis_id:string,id:any){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/profile_required_data/${id}/`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteCharectersDataType(analysis_id:string,id:any){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}character/${id}/analysis/${analysis_id}/delete/`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  setHeaders(account:any){
    let headers = new HttpHeaders()
    if(account.last_logined_role=='ORGAN'){
      headers = headers.append('Organ-Username',account.username)
    }
    return headers
  }
  changeProgramProgressStatus(state:'firstStep'|'profileStep'|'secondStep'|'thirdStep'|'fourthStep',obj:any){
    this.programProgressObj[state] = obj
  }
  getProgramProgressObj(state:'firstStep'|'profileStep'|'secondStep'|'thirdStep'|'fourthStep'){
    return this.programProgressObj[state]
  }
  resetProgressObjc(){
    Object.keys(this.programProgressObj).forEach(
      (i:any)=>{
        this.programProgressObj[i] = {Action:'ADD', loading:false}
      }
    )
  }
  setXStepForm(step:'firstForm'|'requiredQuizForm'|'profileRequiredDatasForm'|'charecterForm'|'requiredDataForm'|'finalForm',data:any){
    if(step=='firstForm') this.firstForm = data
    if(step=='profileRequiredDatasForm') this.profileRequiredDatasForm = data
    if(step=='charecterForm') this.charactersForm = data
    if(step=='requiredDataForm') this.requiredDatasForm = data
    if(step=='requiredQuizForm') this.requiredQuizForm = data
    if(step=='finalForm') this.finalDataForm = data
  }
  getXstepForm(step:'firstForm'|'requiredQuizForm'|'profileRequiredDatasForm'|'charecterForm'|'requiredDataForm'|'finalForm'){
    if(step=='firstForm') return this.firstForm
    if(step=='profileRequiredDatasForm') return this.profileRequiredDatasForm
    if(step=='requiredDataForm') return this.requiredDatasForm
    if(step=='charecterForm') return this.charactersForm
    if(step=='requiredQuizForm') return this.requiredQuizForm
    if(step=='finalForm') return this.finalDataForm
  }
  resetAllstepForm(){
    this.firstForm = null
    this.profileRequiredDatasForm = null
    this.requiredDatasForm = null
    this.charactersForm = null
    this.requiredQuizForm = null
    this.finalDataForm = null
  }
  getFormUsername(){
    return this.getXstepForm('firstForm').analysis
  }
  getAllQuiz(){
    return this.http.get<MultipleCriteria>(`${this.QUIZ_BASE_URL}multiple_criteria/`);
  }
  saveAllQuizList(quizList:any){
    this.quizList = quizList
  }
  returnAllQuizList():any[]{
    return this.quizList
  }
  getAnalyzeList(page:number=1){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/own_form/?page=${page}`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getTarhList(page:number=1){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/?is_secret=False&page=${page}`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteAnalyzeForm(id:string){
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/form/${id}`,{headers}).pipe(catchError(err=>{throw err}))
      })
    )
  }
  
}
